import React from 'react'
import {
  Signers,
  SignersForm,
  SignerInput,
  SmallText,
  AddSigner,
  Icon,
  BoldText,
} from '../../styles/PrepareEsignModalElements'

const PrepareSigners = ({
  isTemplateType,
  signers,
  filledSigners,
  editSigner,
  removeSigner,
  addSigner,
}) => (
  <Signers>
    <BoldText> Who needs to sign? </BoldText>
    <div>
      {isTemplateType && signers.length > 1 && (
        <SmallText size="13px">
          Verify or enter the names of required signers below. Signers can be
          left blank if they aren't relevant.
        </SmallText>
      )}
    </div>
    <div>
      {filledSigners.length > 1 && (
        <SmallText size="13px" color="#CC6900">
          This document will not appear in the borrower application flow because
          there is more than one signer.
        </SmallText>
      )}
    </div>
    <SignersForm>
      {signers.map((signer, index) => (
        <div key={index}>
          {isTemplateType && signer?.label && <label>{signer.label}</label>}
          <SignerInput
            width="200px"
            placeholder="Full Name"
            autoComplete="none"
            type="text"
            name="name"
            value={signer.name || ''}
            onChange={(e) => editSigner(index, 'name', e)}
          />
          <SignerInput
            width="300px"
            placeholder="Email"
            autoComplete="none"
            type="text"
            name="email"
            value={signer.email || ''}
            onChange={(e) => editSigner(index, 'email', e)}
          />
          {!isTemplateType && (
            <span onClick={() => removeSigner(index)}>
              <Icon circleBorder className="fa fa-close" color="#339952" />
            </span>
          )}
        </div>
      ))}
      {!isTemplateType && (
        <AddSigner onClick={() => addSigner()}>
          <Icon
            circleBorder
            style={{ marginRight: '10px' }}
            className="fa fa-plus"
            color="#339952"
          />
          Add Signer
        </AddSigner>
      )}
    </SignersForm>
  </Signers>
)

export default PrepareSigners
